import { useAuth } from '@restworld/feature-authentication';
export function useIsFreemiumUser() {
  var _useAuth = useAuth(),
      user = _useAuth.user;

  return !!(user !== null && user !== void 0 && user.freemium_user);
}